import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import Seo from "@/components/Seo";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground px-6 text-center">
      <Seo title="Page not found" noindex />
      <p className="eyebrow mb-4">404</p>
      <h1 className="font-head text-5xl md:text-6xl">{t("not_found")}</h1>
      <Link to="/" data-testid="notfound-back-home" className="btn-gold mt-10">{t("back_home")}</Link>
    </div>
  );
}
